import { memo } from 'react';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import ToggleNotice from '@wconcept/wconcept-ui-renewal/components/molecules/_notice/ToggleNotice';
import BasicBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/BasicBtn';
import ContTitle from '@wconcept/wconcept-ui-renewal/components/molecules/_title/ContTitle';
import { IconDownload01 } from '@wconcept/wconcept-ui-renewal/components/atoms/svg';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import * as S from './style';

interface CouponGroupData {
  content?: React.ReactNode;
  bgColor?: string;
  titleColor?: 'white' | 'black' | string;
  groupTitle?: string;
}

interface CustomColorType {
  bgColor?: string;
  textColor?: string;
}

type ColorType = 'white' | 'black' | CustomColorType | string;

interface IProps {
  type?: string;
  colorType?: ColorType;
  title?: string;
  subTitle?: string;
  groups: CouponGroupData[];
  noticeList?: string[];
  onClick?: () => void;
  onNoticeToggle?: (active: boolean) => void;
}

// list, card 타입으로 그룹으로 묶인 쿠폰 리스트를 보여주는 컴포넌트
const CouponSection = ({
  type = 'list',
  colorType = 'white',
  title,
  subTitle,
  groups,
  noticeList,
  onClick,
  onNoticeToggle,
}: IProps) => {
  const isCustomColor = typeof colorType === 'object';
  const customColors = isCustomColor ? colorType : undefined;

  const cName = classNameBind([
    'mega-coupon-list',
    !isCustomColor ? `bg-type-${colorType}` : '',
  ]);

  const renderCouponGroup = (groupData: CouponGroupData, index: number) => {
    const {
      content,
      bgColor = '#000',
      titleColor = 'white',
      groupTitle,
    } = groupData;

    if (!content) return null;

    return (
      <S.CouponGroup
        key={`group${index + 1}`}
        className={`coupon-group group${index + 1}`}
        $bgColor={bgColor}
        $titleColor={titleColor}
      >
        {groupTitle && (
          <Text
            weight={500}
            size={15}
            lineHeight={20}
            color={titleColor}
            className="group-title"
            block
          >
            {groupTitle}
          </Text>
        )}
        <div className="list">{content}</div>
      </S.CouponGroup>
    );
  };

  return (
    <S.CouponSection
      className={cName}
      $type={type}
      $bgColor={customColors?.bgColor}
      $textColor={customColors?.textColor}
    >
      <ContTitle
        title={title}
        subTitle={subTitle}
        titleColor={customColors?.textColor}
        subTitleColor={customColors?.textColor}
      />

      <div className="coupon-wrap">{groups.map(renderCouponGroup)}</div>

      <BasicBtn
        text="모든 쿠폰 받기"
        type="line"
        size="large"
        afterIcon={<IconDownload01 />}
        onClick={onClick}
      />

      {noticeList && (
        <ToggleNotice
          noticeList={noticeList}
          onNoticeToggle={onNoticeToggle}
          titleColor={customColors?.textColor}
          noticeColor={customColors?.textColor}
          hideBullet
        />
      )}
    </S.CouponSection>
  );
};

export default memo(CouponSection);
